export enum ERRORS {
  INVALID_CONFIG_PARAMS = 'INVALID_CONFIG_PARAMS',
  REQUEST_5S_TIMEOUT = 'REQUEST_5S_TIMEOUT',
  ETH_SIGENER_NOT_FOUND = 'ETH_SIGENER_NOT_FOUND',
  AR_JWK_NOT_FOUND = 'AR_JWK_NOT_FOUND',
  TO_NOT_FOUND = 'TO_NOT_FOUND',
  SYMBOL_NOT_FOUND = 'SYMBOL_NOT_FOUND',
  TAG_NOT_FOUND = 'TAG_NOT_FOUND',
  TOKEN_NOT_FOUND = 'TOKEN_NOT_FOUND',
  ACCOUNT_NOT_FOUND = 'ACCOUNT_NOT_FOUND',
  EVERHASH_NOT_FOUND = 'EVERHASH_NOT_FOUND',
  CHAIN_TX_HASH_NOT_FOUND = 'CHAIN_TX_HASH_NOT_FOUND',
  INVALID_ACCOUNT_TYPE = 'INVALID_ACCOUNT_TYPE',
  INVALID_ACTION = 'INVALID_ACTION',
  INVALID_AMOUNT = 'INVALID_AMOUNT',
  WITHDRAW_AMOUNT_LESS_THAN_FEE = 'WITHDRAW_AMOUNT_LESS_THAN_FEE',
  INSUFFICIENT_QUICK_WITHDRAWAL_AMOUNT = 'INSUFFICIENT_QUICK_WITHDRAWAL_AMOUNT',
  WITHDRAW_TOKEN_NOT_SUPPORT_QUICK_MODE = 'WITHDRAW_TOKEN_NOT_SUPPORT_QUICK_MODE',
  DEPOSIT_ARWEAVE_PST_MUST_BE_INTEGER = 'DEPOSIT_ARWEAVE_PST_MUST_BE_INTEGER',
  PST_WITHDARW_TO_ARWEAVE_MUST_BE_INTEGER = 'PST_WITHDARW_TO_ARWEAVE_MUST_BE_INTEGER'
}
